import React, { useEffect } from 'react';

const NotFoundPage: React.FC = () => {
  useEffect(() => {
    // Remove background when mounted
    document.body.style.background = 'none';

    // Reset background when unmounted
    return () => {
      document.body.style.background = '';
    };
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>404 - Page Not Found</h1>
      <p>The requested page does not exist.</p>
      <a href="/">Back Home</a>
    </div>
  );
};

export default NotFoundPage;
